import { createAction } from '@reduxjs/toolkit'
import type { AxiosError } from 'axios'

import type { AttachmentItem } from '@/types'

export const UploadResultActions = {
  success: createAction<AttachmentItem>('ATTACHMENT_UPLOAD_RESULT_SUCCESS'),
  error: createAction<AxiosError>('ATTACHMENT_UPLOAD_RESULT_ERROR'),
}
